<template>
  <div class="home">
    <nav-component></nav-component>
    <home-hero></home-hero>
    <home-mission></home-mission>
    <home-business></home-business>
    <home-clients></home-clients>
    <home-news></home-news>
    <home-releases></home-releases>
    <home-company></home-company>
    <home-recruit></home-recruit>
    <site-footer></site-footer>
  </div>
</template>

<script>
import navComponent from '../components/Nav.vue'
import SiteFooter from '../components/SiteFooter.vue'
import HomeHero from '../components/home/Hero.vue'
import HomeMission from '../components/home/Mission.vue'
import HomeBusiness from '../components/home/Business.vue'
import HomeClients from '../components/home/Clients.vue'
import HomeNews from '../components/home/News.vue'
import HomeReleases from '../components/home/Releases.vue'
import HomeCompany from '../components/home/CompanySection.vue'
import HomeRecruit from '../components/home/Recruit.vue'

export default {
  name: 'HomeView',
  components: {
    navComponent,
    SiteFooter,
    HomeHero,
    HomeMission,
    HomeBusiness,
    HomeClients,
    HomeNews,
    HomeReleases,
    HomeCompany,
    HomeRecruit
  }
}
</script>
